import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

// Small labelled value used in detail-page "Details" sections (Quote Details, Order Details).
export default function HeaderField({ label, children }) {
  return (
    <div>
      <Text style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#7A869A', letterSpacing: 0.3, textTransform: 'uppercase' }}>
        {label}
      </Text>
      <div style={{ marginTop: 6 }}>{children}</div>
    </div>
  );
}
